module.exports = __webpack_public_path__ + "static/media/no-path.61a21456.png";